<template>
  <div class="list" name="info">
    <el-card class="searchCard" shadow="never">
      <list-search
        @search="(searchForm, loadingType) => onSubmit(searchForm, loadingType)"
        :searchLoading="searchLoading"
        :resetLoading="resetLoading"
        :formInfo="formInfo"
      ></list-search>
    </el-card>
    <div class="warp-element-table" v-loading="loadingTable">
      <element-table
        ref="tableRef"
        :tableList="tableData"
        :pageOption="pageOption"
        tableName="DyCouponTable"
        @current-change="num => handleChange(`current`, num)"
        @size-change="num => handleChange(`size`, num)"
        @selection-change="handleSelectionChange"
      >
        <template #operate="{ item, index }">
          <div class="warp-link">
            <auth-button
              type="text"
              opt="details"
              @click.native="handleSale(index, item)"
              label="查看"
            >
            </auth-button>
            <auth-button
              type="text"
              opt="edit"
              @click.native="handleEditSale(index, item)"
              label="编辑"
            >
            </auth-button>
            <auth-button
              type="text"
              opt="settle_card_edit"
              class="btmBtn"
              @click.native="settleCardEdit(item)"
              label="结算卡快速修改"
            >
            </auth-button>
            <auth-button
              opt="pos_refund"
              class="btmBtn"
              type="text"
              @click.native="openCardRefund(item)"
              label="开启刷卡退款"
            >
            </auth-button>
          </div>
        </template>
      </element-table>
    </div>
    <settle-form
      v-if="dialogSettleVisible"
      :visible.sync="dialogSettleVisible"
      :merchant-id="selectRowId"
      @submit="saveSettle"
      @close="
        value => {
          dialogSettleVisible = value;
        }
      "
    ></settle-form>
  </div>
</template>

<script>
import qs from 'qs'
import ElementTable from '@/components/ElementTable'
import { merchantSale, updateRefundState } from '@/api/merchant.js'
import settleForm from '../../components/settleForm'

import listSearch from '../components/listSearch'
export default {
  components: {
    listSearch,
    ElementTable,
    settleForm
  },
  data () {
    return {
      // 弹框控制
      dialogSettleVisible: false,
      // 按钮loading
      searchLoading: false,
      resetLoading: false,
      // 表格loading
      loadingTable: false,
      formInfo: {
        merchantName: '',
        merchantId: '',
        merchantType: '',
        merchantStatus: '',
        merchantLevel: '',
        merchantSaleStatus: '',
        FSettleState: '1'
      },
      tableData: [],
      pageOption: {
        total: 0,
        pageNo: 1,
        pageSize: 10
      },
      selectRowId: ''
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    async openCardRefund (row) {
      try {
        await this.$confirm('开启刷卡退款权限需关闭刷卡T0交易结算权限，是否同意？', '温馨提醒')
        const params = qs.stringify({
          merchantId: row.fMerchantId
        })
        const res = await updateRefundState(params)
        if (res.error_code === '0') {
          this.$message({
            message: '开启成功！',
            type: 'success'
          })
          this.getList()
        } else {
          this.$message({
            showClose: true,
            message: res.error_msg,
            type: 'error'
          })
        }
      } catch (err) {
        // 用户点击了取消或者出现了其他错误
        console.log('err: ', err)
      }
    },
    /**
     * @description 保存结算卡修改回调
     * @param {Boolean} flag 是否修改成功
     */
    saveSettle (flag) {
      this.dialogSettleVisible = false
      if (flag) {
        this.getList()
      }
    },
    /**
     * @description 显示结算卡编辑界面
     */
    settleCardEdit (item) {
      this.dialogSettleVisible = true
      this.selectRowId = item.fMerchantId
    },
    /**
     * @description 分页页码改变事件
     */
    handleChange (type, num) {
      if (typeof num === 'object') return
      if (type === 'size') {
        this.pageOption.pageSize = num
        this.pageOption.pageNo = 1
      } else {
        this.pageOption.pageNo = num
      }
      this.getList()
    },
    /**
     * @description 筛选提交事件
     */
    onSubmit (searchForm, loadingType) {
      console.log('loadingType: ', loadingType)
      console.log('searchForm: ', searchForm)
      this[loadingType] = true
      this.pageOption.pageNo = 1
      this.pageOption.total = 0
      this.getList(searchForm, loadingType)
    },
    /**
     * @description 获取表格数据
     */
    async getList (searchForm, loadingType) {
      try {
        if (searchForm) {
          this.formInfo = JSON.parse(JSON.stringify(searchForm))
        }
        const params = Object.assign({}, this.formInfo, this.pageOption)
        this.loadingTable = true
        const res = await merchantSale(params)
        console.log('res: ', res)
        this.tableData = res.list
        this.pageOption.total = +res.totalCount
      } catch (error) {
        console.log('error', error)
      } finally {
        this.loadingTable = false
        if (loadingType) {
          this[loadingType] = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding-left: 16px;
}
</style>
